import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  companyName: any;
  timesHours = [
    '12:00:00 AM', '12:30:00 AM', '01:00:00 AM', '01:30:00 AM', '02:00:00 AM', '02:30:00 AM', '03:00:00 AM', '03:30:00 AM',
    '04:00:00 AM', '04:30:00 AM', '05:00:00 AM', '05:30:00 AM', '06:00:00 AM', '06:30:00 AM', '07:00:00 AM', '07:30:00 AM',
    '08:00:00 AM', '08:30:00 AM', '09:00:00 AM', '09:30:00 AM', '10:00:00 AM', '10:30:00 AM', '11:00:00 AM', '11:30:00 AM',
    '12:00:00 PM', '12:30:00 PM', '01:00:00 PM', '01:30:00 PM', '02:00:00 PM', '02:30:00 PM', '03:00:00 PM', '03:30:00 PM',
    '04:00:00 PM', '04:30:00 PM', '05:00:00 PM', '05:30:00 PM', '06:00:00 PM', '06:30:00 PM', '07:00:00 PM', '07:30:00 PM',
    '08:00:00 PM', '08:30:00 PM', '09:00:00 PM', '09:30:00 PM', '10:00:00 PM', '10:30:00 PM', '11:00:00 PM', '11:30:00 PM',
  ];

  timesHoursSec = [
    '12:00:00', '12:30:00', '01:00:00', '01:30:00', '02:00:00', '02:30:00', '03:00:00', '03:30:00',
    '04:00:00', '04:30:00', '05:00:00', '05:30:00', '06:00:00', '06:30:00', '07:00:00', '07:30:00',
    '08:00:00', '08:30:00', '09:00:00', '09:30:00', '10:00:00', '10:30:00', '11:00:00', '11:30:00',
  ];

  constructor(private http: HttpClient) { }

  setCompanyName(companyName) {
    this.companyName = companyName;
  }

  getCompanyName() {
    return this.companyName;
  }

  getCompanyDetails(custKey: number, companykey: number): Observable<any> {
    const body = {
      custKey: custKey,
      companykey: companykey,
    };
    return this.http.post<any>(`${environment.baseUrl}getCompanyDetails`, body);
  }

  getcustomerVehicleClassQty(TSXKey: number): Observable<any> {
    const body = {
      TSXKey: TSXKey,
    };
    return this.http.post<any>(`${environment.baseUrl}customerVehicleClassQty`, body);
  }

  getCustomerApplyingServices(TSXKey: number): Observable<any> {
    const body = {
      TSXKey: TSXKey,
    };
    return this.http.post<any>(`${environment.baseUrl}customerApplyingServices`, body);
  }

  getCustomerLoginDetails(customerKey: number): Observable<any> {
    const body = {
      customerKey: customerKey,
    };
    return this.http.post<any>(`${environment.baseUrl}getCustomerLoginDetails`, body);
  }

  getCustomerLogoutDetails(customerKey: number): Observable<any> {
    const body = {
      customerKey: customerKey,
    };
    return this.http.post<any>(`${environment.baseUrl}getCustomerLogoutDetails`, body);
  }

  getCustomerAddress(customerKey: number): Observable<any> {
    const body = {
      custKey: customerKey,
    };
    return this.http.post<any>(`${environment.baseUrl}getCustomerAddress`, body);
  }

  getCustomerContact(customerKey: number): Observable<any> {
    const body = {
      custKey: customerKey,
    };
    return this.http.post<any>(`${environment.baseUrl}getCustomerContact`, body);
  }

  getCustomerAccountInfo(custKey: number): Observable<any> {
    const body = {
      custKey: custKey,
    };
    return this.http.post<any>(`${environment.baseUrl}getCustomerAccountInfo`, body);
  }

  getCustomerProtocolsBeta(customerKey: number): Observable<any> {
    const body = {
      customerKey: customerKey,
    };
    return this.http.post<any>(`${environment.baseUrl}getCustomerProtocolsBeta`, body);
  }

  getCodServiceTypeOptions(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getCodServiceTypeOptions`);
  }

  getDefaultsProtocolsBeta(customerKey: number): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getDefaultsProtocolsBeta/${customerKey}`);
  }

  getOutboundLineOptions(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getOutboundLineOptions`);
  }

  getCustomerAccountNo(customerKey: number): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}GetCustomerAccountNumber/${customerKey}`);
  }

  updateCustomerApplyService(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}updateApplyingCompanyServices`, data);
  }

  updateCustomerDetails(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}updateCompanyDetails`, data);
  }

  updateCustomerProfile(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}updateCustomerProfile`, data);
  }

  InviteNewUser(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}api/customers/inviteNewUser`, data);
  }

  getRoleTypes() {
    return this.http.get(`${environment.baseUrl}api/customers/getRoleTypes`);
  }

  getCompanyRoleCustomized(intCustomerId) {
    return this.http.get(`${environment.baseUrl}api/customers/getCompanyRoleCustomized/${intCustomerId}`);
  }
  getApprovalLimit(intCompanyRoleKey) {
    return this.http.get(`${environment.baseUrl}api/customers/getApprovalLimit/${intCompanyRoleKey}`);
  }

  insertUpdateCompanyRoleCustomized(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}api/customers/InsertUpdateCompanyRoleCustomized`, data);
  }

  getCustomerUserInformationById(customerKey): Observable<any> {
    return this.http.get(`${environment.baseUrl}api/customers/getCustomerUserInformationById/${customerKey}`);
  }

  updateInviteUserProfile(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}api/customers/updateInviteUserProfile`, data);
  }

  getCustomerUserRoleType() {
    return this.http.get(`${environment.baseUrl}api/customers/getCustomerUserRoleType`);
  }

  UserHierarchy(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}UserHierarchy`, data);
  }

  getUserHierarchy(customerKey) {
    return this.http.get(`${environment.baseUrl}getUserHierarchy/${customerKey}`);
  }

  getCustomerHierarchyRegion(companykey): Observable<any> {
    return this.http.get(`${environment.baseUrl}getCustomerHierarchyRegion/${companykey}`);
  }

  getCustomerHierarchyDivision(companykey): Observable<any> {
    return this.http.get(`${environment.baseUrl}getCustomerHierarchyDivision/${companykey}`);
  }

  getCustomerHierarchyLocation(companykey): Observable<any> {
    return this.http.get(`${environment.baseUrl}getCustomerHierarchyLocation/${companykey}`);
  }

  getCustomerUserList(data) {
    return this.http.post<any>(`${environment.baseUrl}getCustomerUserList`, data);
  }

  updateCustomerUserInformation(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}api/customers/updateCustomerUserInformation`, data);
  }

  getCorporateUserInviteList(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}getCorporateUserInviteList`, data);
  }

  getRegionUserInviteList(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}getRegionUserInviteList`, data);
  }

  getDivisionUserInviteList(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}getDivisionUserInviteList`, data);
  }

  getInvitedUserListByCustomer(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}api/customers/getInvitedUserListByCustomer`, data);
  }

  createTempHierarchyTable(data) {
    return this.http.post<any>(`${environment.baseUrl}createTempHierarchyTable`, data);
  }

  addProtocols(data: any): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}addEditProtocol`, data);
  }

  sendProtocalChangeRequest(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}api/customers/protocolEmail`, data);
  }


  // API call to get all hierarchy data.
  getHierarchyDetails(intCustomerKey): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getHierarchyDetails/${intCustomerKey}`);
  }

  deleteInviteUser(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}api/customers/deleteInviteUser`, data);
  }

  deleteUserHierarchy(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}api/customers/deleteUserHierarchy`, data);
  }

  // delete national account.
  deleteNationalAccountProgram(nationalAccountKey): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}deleteNationalAccountProgram/${nationalAccountKey}`);
  }

  getCustomerRepairLimit(customerKey): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getCustomerRepairLimit/${customerKey}`);
  }

  getCustomerApprovalList(customerKey): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getCustomerapprovalList/${customerKey}`);
  }

  addUpdateApprovalList(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}InsertUpdateAprrovalList`, data);
  }

  deleteApproval(customerKey): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}deleteApproval/${customerKey}`);
  }

  addUpdateRepairLimit(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}InsertUpdateRepairLimit`, data);
  }

  getPSCProviderServiceCharge(customerKey): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getPSCProviderServiceCharge/${customerKey}`);
  }

  updatePSCProviderServiceCharge(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}updatePSCProviderServiceCharge`, data);
  }

  getInvitedCustomerList(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}api/customers/getInvitedCustomerList`);
  }

  cancelCustomerInvite(data): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}api/customers/cancleCustomerInvite/${data}`);
  }

  changeUserPassword(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}api/customers/updateUserPassword`, data);
  }

  uploadProfilePicture(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}api/customers/uploadFile`, data);
  }

  deleteProfilePicture(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}api/customers/deleteFile`, data);
  }

  updateImageURL(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}api/customers/updateImageURL`, data);
  }
}
